import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from '../../../core/modules/shared.module';

import {FuseModulesComponent} from './modules.component';

const routes = [{path: 'modules', component: FuseModulesComponent}];

@NgModule({
  declarations: [FuseModulesComponent],
  imports: [SharedModule, RouterModule.forChild(routes)],
  exports: [FuseModulesComponent]
})

export class FuseModulesModule {}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/modules/modules.module.ts